//1
import React, { useEffect } from 'react'
import MovieListing from "../MovieListing/MovieListing";

import { useDispatch } from 'react-redux';
import {  fetchAsyncMovies, fetchAsyncShows } from '../../features/movies/movieSlice';
const Home = () => {

  const dispatch = useDispatch();
const movieText = "Blue"
const showText = "Blue"
  useEffect(() => {
    dispatch(fetchAsyncMovies(movieText));
    dispatch(fetchAsyncShows(showText));

  },[dispatch])

  return (
    <div>

      <div className='banner-img'></div>
      <MovieListing />

    </div>
  )
}

export default Home